import { SystemEntity } from '@erp/shared-types';

/**
 * Display name mapping for system entities
 * Maps each SystemEntity to a human-readable display name
 */
export const systemEntityDisplayNames: Record<SystemEntity, string> = {
  // CORE
  [SystemEntity.CORE_MEMORY_BANK_NOTE]: 'Memory Bank Note',
  [SystemEntity.CORE_MEMORY_BANK_NOTE_USAGE]: 'Memory Bank Usage',
  [SystemEntity.ORGANIZATION]: 'Organization',
  [SystemEntity.CORE_DOCUMENT]: 'Document',
  [SystemEntity.CORE_DOCUMENT_OCR_RESULT]: 'OCR Result',

  // AR
  [SystemEntity.AR_CUSTOMER]: 'Customer',
  [SystemEntity.AR_STAGED_SALES_ORDER]: 'Sales Order Draft',
  [SystemEntity.AR_SALES_ORDER]: 'Sales Order',
  [SystemEntity.AR_SALES_ORDER_LINE_ITEM]: 'Sales Order Line Item',

  // AP
  [SystemEntity.AP_INVOICE]: 'AP Invoice',
  [SystemEntity.AP_INVOICE_LINE_ITEM]: 'AP Invoice Line Item',
  [SystemEntity.AP_SUPPLIER]: 'Supplier',
  [SystemEntity.INTERNAL_PURCHASE_ORDER]: 'Purchase Order',
  [SystemEntity.INTERNAL_PURCHASE_ORDER_LINE_ITEM]: 'PO Line Item',

  // FINANCE
  [SystemEntity.PAYMENT]: 'Payment',
  [SystemEntity.FINANCIAL_TRANSACTION]: 'Financial Transaction',
  [SystemEntity.CHARGE]: 'Charge',

  // SUPPLY CHAIN MANAGEMENT
  [SystemEntity.SCM_SHIPMENT]: 'Shipment',
  [SystemEntity.SHIPPING_DOCUMENT]: 'Shipping Document',
  [SystemEntity.SHIPPING_DOCUMENT_LINE_ITEM]: 'Shipping Document Line Item',

  // EMAILS
  [SystemEntity.INBOUND_EMAIL]: 'Inbound Email',
  [SystemEntity.OUTBOUND_EMAIL]: 'Outbound Email',

  // WORKFLOWS
  [SystemEntity.WORKFLOW_DEFINITION]: 'Workflow Definition',
  [SystemEntity.WORKFLOW_RUN]: 'Workflow Run',
  [SystemEntity.STEP_RUN]: 'Step Run',
};

/**
 * Get the display name for a system entity
 */
export function getEntityDisplayName(entityType: SystemEntity): string {
  return (
    systemEntityDisplayNames[entityType] ?? `Unknown Entity (${entityType})`
  );
}
